module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-scary.ad540029.png";